export default function LegalFooter() {
  return (
    <footer className="legal-footer" aria-label="Membership information">
      <nav aria-label="Terms and contact">
        <a href="/terms" target="_blank" rel="noopener noreferrer">Membership Terms and Conditions</a>
        <a href="/fair-use" target="_blank" rel="noopener noreferrer">Fair Use Policy</a>
        <a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        <a href="mailto:hello@calmbutcapable.com">Contact Calm But Capable</a>
      </nav>
      <p>Calm But Capable LTD · Company number 17360057</p>
    </footer>
  );
}
